import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

export const loginGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  // Si hay un token en los query params, permitir el acceso para que el componente lo procese
  if (route.queryParams['token']) {
    return true;
  }

  if(authService.isAuthenticated()) {
    router.navigateByUrl('dashboard');
    return false;
  }

  return true;
};
